// meeting-guides.ts — Guides de réunion : référentiel, sélection par
// comité, déclaration sur une réunion.
import { req } from './_internals.js';

export const meetingGuidesApi = {
  // Référentiel tenant
  getGuideDefinitions: () => req('GET', '/meeting-guides/definitions'),
  createGuideDefinition: (d: unknown) => req('POST', '/meeting-guides/definitions', d),
  updateGuideDefinition: (id: number | string, d: unknown) =>
    req('PUT', '/meeting-guides/definitions/' + id, d),
  deleteGuideDefinition: (id: number | string) =>
    req('DELETE', '/meeting-guides/definitions/' + id),
  reorderGuideDefinitions: (order: unknown) =>
    req('PUT', '/meeting-guides/definitions/reorder', order),

  // Matrice réunions × guides d'une période (vue « Guides » de
  // #meetings-records). Bornée aux réunions animées par l'appelant.
  getGuidesOverview: (params?: { date_from?: string; date_to?: string }) => {
    const qs = new URLSearchParams();
    if (params?.date_from) qs.set('date_from', params.date_from);
    if (params?.date_to) qs.set('date_to', params.date_to);
    const q = qs.toString();
    return req('GET', '/meeting-guides/overview' + (q ? '?' + q : ''));
  },

  // Sélection par type de comité
  getCommitteeGuides: (committeeId: number | string) =>
    req('GET', '/meeting-guides/committees/' + committeeId),
  setCommitteeGuides: (committeeId: number | string, d: unknown) =>
    req('PUT', '/meeting-guides/committees/' + committeeId, d),

  // Par réunion
  getMeetingGuides: (meetingId: number | string) =>
    req('GET', '/meeting-guides/meetings/' + meetingId),
  // Marque le guide dont on vient de créer l'action standard, pour ne plus
  // reproposer le CTA (à personne, pas seulement à son auteur).
  markGuideActionCreated: (meetingId: number | string, guideId: number | string) =>
    req('POST', '/meeting-guides/meetings/' + meetingId + '/' + guideId + '/action-created'),
  setMeetingGuideStatus: (meetingId: number | string, guideId: number | string, d: unknown) =>
    req('PATCH', '/meeting-guides/meetings/' + meetingId + '/' + guideId, d),
  reorderMeetingGuides: (meetingId: number | string, order: unknown) =>
    req('PUT', '/meeting-guides/meetings/' + meetingId + '/reorder', order),
  setMeetingAgenda: (meetingId: number | string, d: unknown) =>
    req('PUT', '/meeting-guides/meetings/' + meetingId + '/agenda', d),
  getPreviousAgenda: (meetingId: number | string) =>
    req('GET', '/meeting-guides/meetings/' + meetingId + '/previous-agenda'),
};
